module.exports = __webpack_public_path__ + "img/twelve_fifteen.50c43a25.svg";